<div class="slot__container" #imgContainer>
  <!-- Paste overlay -->
  @if (isPasting()) {
    <div class="slot__paste-overlay" (click)="onPasteAreaClick($event)">
      <input
        type="text"
        class="slot__paste-input"
        #pasteInput
        (paste)="onPaste($event)"
      />
      <span class="slot__paste-label">Press <kbd>Ctrl+V</kbd> with<br/>an image in clipboard.</span>
      <span class="slot__paste-focus">Click to focus<br/>before pasting.</span>
      <button type="button" class="slot__paste-close atmos-icon-btn" (click)="onClosePaste($event)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }

  <!-- Action buttons (top row) -->
  <div class="slot__actions slot__actions--top">
    <button
      type="button"
      class="slot__action-btn atmos-icon-btn"
      (click)="onPickFile()"
      skyTooltip="Select image file"

    >
      <mat-icon>upload_file</mat-icon>
    </button>

    <button
      type="button"
      class="slot__action-btn atmos-icon-btn"
      (click)="onStartPaste(false, $event)"
      skyTooltip="Paste image"
    >
      <mat-icon>content_paste</mat-icon>
    </button>

    <button
      type="button"
      class="slot__action-btn atmos-icon-btn"
      (click)="onStartPaste(true, $event)"
      skyTooltip="Paste images in bulk"
    >
      <mat-icon>start</mat-icon>
    </button>
  </div>

  <!-- Action buttons (bottom row) -->
  <div class="slot__actions slot__actions--bottom">
    @if (!iconUrl()) {
      <button
        type="button"
        class="slot__action-btn atmos-icon-btn"
        (click)="onOpenIconPicker()"
        skyTooltip="Add icon to corner"

      >
        <mat-icon>checkroom</mat-icon>
      </button>
    }

    <button
      type="button"
      class="slot__action-btn atmos-icon-btn"
      (click)="onClear()"
      skyTooltip="Remove image"

    >
      <mat-icon>clear</mat-icon>
    </button>
  </div>

  <!-- Image with panzoom -->
  <div class="slot__img-wrapper">
    <img
      #imgEl
      class="slot__img"
      [src]="imageUrl()"
      crossorigin="anonymous"
      (load)="onImageLoaded()"
      draggable="false"
    />
  </div>

  <!-- Icon overlay badge -->
  @if (iconUrl()) {
    <div class="slot__icon-badge">
      <img
        #iconEl
        [src]="iconUrl()"
        class="slot__icon-img"
        crossorigin="anonymous"
        (click)="onIconClick()"
      />
    </div>
  }
</div>

<!-- Icon picker (outside container so it overlays correctly) -->
@if (showIconPicker()) {
  <app-icon-picker
    (closed)="onIconPickerClosed()"
    (selected)="onIconPickerSelected($event)"
  />
}
